// Mock data for Zaruma Home Repairs LLC

export const companyInfo = {
  name: "Zaruma Home Repairs LLC",
  phone: "973-419-9225",
  email: "zarumaoscar97@gmail.com",
  address: "Servicing New Jersey & New York Area",
  tagline: "Free estimates. Satisfaction Guaranteed.",
  yearsExperience: "15+",
  projectsCompleted: "500+",
  logoUrl: "/logo.png",
  whatsapp: "+19734199225"
};

export const services = [
  {
    id: 1,
    name: "Plomería",
    nameEn: "Plumbing",
    description: "Reparación y instalación de sistemas de plomería residencial y comercial",
    icon: "Wrench"
  },
  {
    id: 2,
    name: "Electricidad",
    nameEn: "Electrical",
    description: "Servicios eléctricos completos, instalaciones y reparaciones certificadas",
    icon: "Zap"
  },
  {
    id: 3,
    name: "Pintura",
    nameEn: "Painting",
    description: "Pintura interior y exterior de alta calidad con acabados profesionales",
    icon: "Paintbrush"
  },
  {
    id: 4,
    name: "Albañilería",
    nameEn: "Masonry",
    description: "Trabajos de albañilería, ladrillos, bloques y concreto",
    icon: "Hammer"
  },
  {
    id: 5,
    name: "Pisos",
    nameEn: "Flooring",
    description: "Instalación de todo tipo de pisos: madera, laminado, cerámica y más",
    icon: "Box"
  },
  {
    id: 6,
    name: "Reparación de Drywall",
    nameEn: "Drywall Repairs",
    description: "Reparación y instalación profesional de paneles de yeso",
    icon: "Square"
  },
  {
    id: 7,
    name: "Reparación de Techos",
    nameEn: "Roof Repairs",
    description: "Reparación e instalación de techos residenciales y comerciales",
    icon: "Home"
  },
  {
    id: 8,
    name: "Molduras y Acabados",
    nameEn: "Molding and Trims",
    description: "Instalación de molduras decorativas y acabados finos",
    icon: "Minus"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "María González",
    rating: 5,
    comment: "Excelente servicio! Repararon mi techo en tiempo récord y el precio fue muy justo. 100% recomendados.",
    service: "Roof Repairs",
    date: "2024-11"
  },
  {
    id: 2,
    name: "John Smith",
    rating: 5,
    comment: "Very professional team. They completely renovated my bathroom and the results exceeded my expectations!",
    service: "Plumbing & Flooring",
    date: "2024-10"
  },
  {
    id: 3,
    name: "Carlos Ramírez",
    rating: 5,
    comment: "Trabajo de calidad y atención personalizada. Pintaron toda mi casa y quedó perfecta. Gran equipo!",
    service: "Painting",
    date: "2024-12"
  },
  {
    id: 4,
    name: "Lisa Anderson",
    rating: 5,
    comment: "Honest, reliable, and skilled. Fixed our electrical issues quickly and safely. Highly recommend!",
    service: "Electrical",
    date: "2024-11"
  }
];

export const gallery = [
  {
    id: 1,
    image: "/project1.jpg",
    title: "Plumbing Renovation",
    category: "Plumbing"
  },
  {
    id: 2,
    image: "/project2.jpg",
    title: "Exterior Painting - Blue House",
    category: "Painting"
  },
  {
    id: 3,
    image: "/project3.jpg",
    title: "Roof Cleaning & Maintenance",
    category: "Roof Repairs"
  },
  {
    id: 4,
    image: "/project4.jpg",
    title: "Window & Siding Installation",
    category: "General Construction"
  },
  {
    id: 5,
    image: "/project5.jpg",
    title: "Complete Exterior Makeover",
    category: "Painting"
  },
  {
    id: 6,
    image: "/project6.jpg",
    title: "Window Installation with Shutters",
    category: "General Construction"
  },
  {
    id: 7,
    image: "/project7.jpg",
    title: "Interior Framing & Drywall",
    category: "Drywall Repairs"
  },
  {
    id: 8,
    image: "/project8.jpg",
    title: "Complete Roof Replacement",
    category: "Roof Repairs"
  },
  {
    id: 9,
    image: "/project9.jpg",
    title: "Mobile Home Roof Installation",
    category: "Roof Repairs"
  },
  {
    id: 10,
    image: "/project10.jpg",
    title: "Interior Structural Framing",
    category: "General Construction"
  },
  {
    id: 11,
    image: "/project11.jpg",
    title: "Hardwood Flooring Installation",
    category: "Flooring"
  },
  {
    id: 12,
    image: "/project12.jpg",
    title: "Construction Site Management",
    category: "General Construction"
  },
  {
    id: 13,
    image: "/project13.jpg",
    title: "Bathroom Renovation & Insulation",
    category: "General Construction"
  },
  {
    id: 14,
    image: "/project14.jpg",
    title: "Laminate Flooring Project",
    category: "Flooring"
  },
  {
    id: 15,
    image: "/project15.jpg",
    title: "Flooring Installation with Makita Tools",
    category: "Flooring"
  },
  {
    id: 16,
    image: "/project16.jpg",
    title: "Floor Transition & Subfloor Repair",
    category: "Flooring"
  },
  {
    id: 17,
    image: "/project17.jpg",
    title: "Electrical Panel Work",
    category: "Electrical"
  },
  {
    id: 18,
    image: "/project18.jpg",
    title: "Ceiling Light Fixture Installation",
    category: "Electrical"
  },
  {
    id: 19,
    image: "/project19.jpg",
    title: "Professional Light Installation",
    category: "Electrical"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "15+ Años de Experiencia",
    description: "Más de una década de experiencia en reparaciones y construcción residencial",
    icon: "Award"
  },
  {
    id: 2,
    title: "Presupuestos Gratuitos",
    description: "Estimaciones sin compromiso para todos nuestros servicios",
    icon: "DollarSign"
  },
  {
    id: 3,
    title: "Satisfacción Garantizada",
    description: "Tu satisfacción es nuestra prioridad. Trabajo garantizado",
    icon: "CheckCircle"
  },
  {
    id: 4,
    title: "Profesionales Certificados",
    description: "Equipo de técnicos certificados y con licencia",
    icon: "Users"
  }
];
